export default __webpack_public_path__ + "static/media/explodely_logo.5e30c57f.png";